import React from "react"

import Img from "gatsby-image"
import ReactPlayer from "react-player"
import styled from "styled-components"
import { Grid } from "../../atoms/grid"
import { Box } from "../../atoms/box"

import { Card } from "../../molecules/card"
import { withLightbox } from "../../molecules/lightbox"

import { Settings } from "../../../styles/theme"

import chunk from "lodash.chunk"

import Carousel from "../../molecules/carousel"

const Gallerystyle = styled.div`
  position: relative;
  .constraint {
    max-width: ${props => (props.one ? "800px" : "80%")};
    position: relative;
    > div {
      margin-left: -8px;
      width: 100%;
    }
  }
  .masonry-brick {
    flex: 1 1 23%;
    margin: 0 8px 8px 0;
    .gatsby-image-wrapper {
      height: ${props => (props.one ? "auto" : "100%")};
    }
  }
  .arrows {
    display: none;
    color: ${Settings.primaryColor};
    font-weight: 700;
    font-size: 1.5rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .prev {
    left: -5%;
  }
  .next {
    right: -4%;
    text-align: right;
  }
  .show.arrows {
    display: block;
  }
`

const Image = styled.div`
  display: ${props => (props.slide === props.selected ? "block" : "none")};
`

export const ImgGallery = ({
  data,
  toggle,
  toggleLightbox,
  selected,
  setSelected,
  setSelectedAdditional,
  selectedAdditional,
  useLightbox,
}) => (
  <Gallerystyle
    one={data.length === 1 ? true : false}
    selected={selected}
    slides={Math.ceil(data.length / 8)}
  >
    <Box
      fluid={data[selected].fluid}
      toggle={toggle}
      toggleLightbox={toggleLightbox}
      prev={selected === 0 ? false : selected - 1}
      next={data.length > selected + 1 ? selected + 1 : false}
      setSelected={setSelected}
    />
    <div className="constraint">
      <div
        className={
          Math.ceil(data.length / 8 - 1) > selectedAdditional
            ? "next arrows show"
            : "next arrows"
        }
        onClick={() => setSelectedAdditional(selectedAdditional + 1)}
      >
        {">"}
      </div>
      <div
        className={selectedAdditional > 0 ? "prev arrows show" : "prev arrows"}
        onClick={() => setSelectedAdditional(selectedAdditional - 1)}
      >
        {"<"}
      </div>
      <Grid>
        {data.map((item, i) => (
          <Image
            className={"masonry-brick"}
            onClick={() =>
              useLightbox !== false ? [setSelected(i), toggleLightbox()] : ""
            }
            slide={Math.ceil((i + 1) / 8)}
            selected={selectedAdditional + 1}
            key={i}
          >
            <Img fluid={item.fluid} />
          </Image>
        ))}
      </Grid>
    </div>
  </Gallerystyle>
)

export const ImageGallery = withLightbox(ImgGallery)

const Column = styled.div`
  @media screen and (max-width: ${Settings.sizeM}) {
    flex: 1 1 48% !important;
  }
`

const Seven = ({ data, toggle, toggleLightbox, selected, setSelected }) => {
  const dataOrganised = chunk(data, 10)
  return (
    <div className="constraint">
      <Carousel slide={1}>
        {dataOrganised.map((dat, k) => (
          <div key={k}>
            <Grid columns={4}>
              {dat.length > 1 ? (
                <Column>
                  <Box
                    fluid={dat[selected].fluid}
                    toggle={toggle}
                    toggleLightbox={toggleLightbox}
                    prev={selected === 0 ? false : selected - 1}
                    next={dat.length > selected + 1 ? selected + 1 : false}
                    setSelected={setSelected}
                  />
                  {dat.slice(0, 2).map((item, i) => (
                    <div
                      onClick={() => {
                        setSelected(i)
                        toggleLightbox()
                      }}
                    >
                      <Card
                        height={i === 0 ? "370px" : "185px"}
                        key={i}
                        fluid={item.fluid}
                      />
                    </div>
                  ))}
                </Column>
              ) : (
                <h4>There are no items</h4>
              )}
              {dat.length > 3 ? (
                <Column>
                  <div
                    onClick={() => {
                      setSelected(2)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="185px"
                      fluid={dat[2].fluid}
                      onClick={() => {
                        setSelected(2)
                        toggleLightbox()
                      }}
                    />
                  </div>
                  <div
                    onClick={() => {
                      setSelected(3)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="185px"
                      fluid={dat[3].fluid}
                      onClick={() => {
                        setSelected(3)
                        toggleLightbox()
                      }}
                    />
                  </div>
                  <div
                    onClick={() => {
                      setSelected(4)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="185px"
                      fluid={dat[4].fluid}
                      onClick={() => {
                        setSelected(4)
                        toggleLightbox()
                      }}
                    />
                  </div>
                </Column>
              ) : (
                ""
              )}
              {dat.length > 5 ? (
                <Column>
                  <div
                    onClick={() => {
                      setSelected(5)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="278px"
                      fluid={dat[5].fluid}
                      onClick={() => {
                        setSelected(5)
                        toggleLightbox()
                      }}
                    />
                  </div>
                  <div
                    onClick={() => {
                      setSelected(6)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="276px"
                      fluid={dat[6].fluid}
                      onClick={() => {
                        setSelected(6)
                        toggleLightbox()
                      }}
                    />
                  </div>
                </Column>
              ) : (
                ""
              )}
              {dat.length > 7 ? (
                <Column>
                  <div
                    onClick={() => {
                      setSelected(7)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="185px"
                      fluid={dat[7].fluid}
                      onClick={() => {
                        setSelected(7)
                        toggleLightbox()
                      }}
                    />
                  </div>
                  <div
                    onClick={() => {
                      setSelected(8)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="185px"
                      fluid={dat[8].fluid}
                      onClick={() => {
                        setSelected(8)
                        toggleLightbox()
                      }}
                    />
                  </div>
                  <div
                    onClick={() => {
                      setSelected(9)
                      toggleLightbox()
                    }}
                  >
                    <Card
                      height="185px"
                      fluid={dat[9].fluid}
                      onClick={() => {
                        setSelected(9)
                        toggleLightbox()
                      }}
                    />
                  </div>
                </Column>
              ) : (
                ""
              )}
            </Grid>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export const SevenGallery = withLightbox(Seven)

const VideoGalleryStyle = styled.div`
  padding: 2rem 0;
  > div {
    width: 100% !important;
  }
  .arrows {
    display: none;
    color: ${Settings.primaryColor};
    font-weight: 700;
    font-size: 1.5rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .prev {
    left: -5%;
  }
  .next {
    right: -4%;
    text-align: right;
  }
  .show.arrows {
    display: block;
  }
`

const VideoInstance = styled.div`
  padding: 1rem;
  flex: 1 1 27% !important;
  position: relative;
  display: ${props => (props.selected === props.slide ? "block" : "none")};
  > div {
    height: 100% !important;
    width: 100% !important;
  }
  .trigger {
    position: absolute;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
`

export const VidGallery = ({
  data,
  toggle,
  toggleLightbox,
  selected,
  setSelected,
  setSelectedAdditional,
  selectedAdditional,
}) => (
  <VideoGalleryStyle className="constraint">
    <ReactPlayer url={data[selected]} controls />
    <div style={{ position: "relative" }}>
      <div
        className={
          Math.ceil(data.length / 3 - 1) > selectedAdditional
            ? "next arrows show"
            : "next arrows"
        }
        onClick={() => setSelectedAdditional(selectedAdditional + 1)}
      >
        {">"}
      </div>
      <div
        className={selectedAdditional > 0 ? "prev arrows show" : "prev arrows"}
        onClick={() => setSelectedAdditional(selectedAdditional - 1)}
      >
        {"<"}
      </div>
      <Grid>
        {data.map((video, i) => (
          <VideoInstance
            slide={Math.ceil((i + 1) / 3)}
            selected={selectedAdditional + 1}
          >
            <div className="trigger" onClick={() => setSelected(i)} />
            <ReactPlayer url={video} key={i} />
          </VideoInstance>
        ))}
      </Grid>
    </div>
  </VideoGalleryStyle>
)

export const VideoGallery = withLightbox(VidGallery)
